import React from 'react'

const SalesOrder = () => {
  return (
    <div>SalesOrder</div>
  )
}

export default SalesOrder